import { Button, Card } from "react-bootstrap";
import styled from "styled-components";
import DownIcon from "../../assets/icons/Down.svg";

const StyledCardTitle = styled.p`
    font-size: 16px;
    line-height: 120%;
    color: #9654ff;
    margin: 0;
`;

const StyledCardTeacher = styled.span`
    font-size: 17px;
    line-height: 150%;
    color: #1e1e1e;
`;

const StyledCardHour = styled.span`
    font-weight: 500;
    font-size: 18px;
    color: #1e1e1e;
    padding-right: 8px;
    margin: 0;
    width: auto;
`;

const StyledFlexDivSpaceBetween = styled.div`
    display: flex;
    justify-content: space-between;
`;

const StyledFlexDivAlignCenter = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const StyledFlexDivWithGap = styled.div`
    display: flex;
    gap: 14px;
`;

const StyledCardAvailableHours = styled.div`
    font-size: 15px;
    text-align: center;
    padding: 6px 14px;
    background: #9654ff;
    border-radius: 32px;
    color: #ffff;
    display: inline-grid;
`;

const StyledInformationPlanNotFound = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 24px 16px;
    gap: 16px;
    width: 100%;
    max-width: 735px;
    background: #f0f2f2;
    border-radius: 8px;
`;

const StyledInformationPlan = styled.div`
    padding: 24px 16px;
    gap: 16px;
    height: 182px;
    background: #f0f2f2;
    border-radius: 8px;
`;

const StyledPrimayButton = styled(Button)`
    width: 112px;
    height: 48px;
    background: #8a0538;
    border: 1px solid #8a0538;
    border-radius: 24px;
    > a {
        color: inherit;
        text-decoration: inherit;
    }
    &:disabled {
        width: 112px;
        height: 48px;
        background: #e4e4e4;
        border: 1px solid #e4e4e4;
        border-radius: 24px;
        color: #404040;
        font-family: "Source Sans Pro";
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 100%;
    }
    &:hover {
        background: #570013 !important;
        border: 1px solid #570013 !important;
    }
    &.btn:focus {
        outline: none;
        box-shadow: none;
        background: #8a0538;
        border: 1px solid #8a0538;
        color: #ffff;
    }
    &.btn:active {
        outline: none;
        box-shadow: none;
        background: #8a0538;
        border: 1px solid #8a0538;
        color: #ffff;
    }
`;

const StyledDefaultButton = styled(Button)`
    width: 100px;
    height: 48px;
    background: #fff;
    border: 1px solid #8a0538;
    border-radius: 24px;
    color: #8a0538;
    margin: 0px 12px 0px;
    font-size: 16px;
    line-height: 100%;
    > a {
        color: inherit;
        text-decoration: inherit;
    }
    > svg {
        fill: #8a0538;
    }
    &:disabled {
        width: 130px;
        height: 48px;
        background: #e4e4e4;
        border: 1px solid #e4e4e4;
        border-radius: 24px;
        color: #404040;
        font-size: 16px;
        line-height: 100%;
        > svg {
            fill: #787878;
        }
    }
    &:hover {
        background: #570013 !important;
        border: 1px solid #570013 !important;
        > svg {
            fill: #ffff !important;
        }
    }
    &.btn:focus {
        outline: none;
        box-shadow: none;
        background: #8a0538;
        border: 1px solid #8a0538;
        color: #ffff;
        > svg {
            fill: #ffff;
        }
    }
    &.btn:active {
        outline: none;
        box-shadow: none;
        background: #8a0538;
        border: 1px solid #8a0538;
        color: #ffff;
        > svg {
            fill: #ffff;
        }
    }
`;

const StyledDefaultButtonLink = styled(Button)`
    color: #8a0538;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
    > a {
        color: inherit;
        text-decoration: inherit;
    }

    &:disabled {
        color: #787878 !important;
        font-size: 16px;
        line-height: 100%;
        > svg {
            fill: #787878 !important;
        }
    }
    &:hover {
        color: #8a0538 !important;
        > svg {
            fill: #8a0538 !important;
        }
    }
    &.btn:focus {
        outline: none;
        box-shadow: none;
        color: #8a0538 !important;
        > svg {
            fill: #8a0538 !important;
        }
    }
    &.btn:active {
        outline: none;
        box-shadow: none;
        color: #8a0538 !important;
        > svg {
            fill: #8a0538 !important;
        }
    }
`;

const StyledTextPlan = styled.p<{
    color?: any;
    padding?: number;
    margin?: number;
}>`
    font-size: 15px;
    line-height: 150%;
    margin: 0;
    margin-top: ${({ margin }) => (margin ? `${margin}px` : 0)};
    color: ${({ color }) => (color ? `${color}` : "#404040")};
    padding-left: ${({ padding }) => (padding ? `${padding}px` : 0)};
`;

const StyledText = styled.p`
    font-weight: 700;
    font-size: 24px;
    line-height: 130%;
    margin: 0;
`;

const StyledTitlePlan = styled.h1<{ padding?: number }>`
    font-weight: 700;
    font-size: 20px;
    line-height: 25px;
    display: flex;
    align-items: center;
    color: #383838;
    margin: 0;
    padding-bottom: ${({ padding }) => (padding ? `${padding}px` : "24px")};
`;

const StyledTitleHistoric = styled.h1`
    font-weight: 700;
    font-size: 24px;
`;

const StyledHistoricInfoIcons = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 25px 0;
`;

const StyledModalHeader = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 8px;
    gap: 16px;
    height: 48px;
    background: #f0f2f2;
    border: 1px solid #f0f2f2;
`;

const StyledContainerBody = styled.div`
    padding-top: 24px;
    padding-left: 10px;
`;

const StyledSelectTeacherDiv = styled.div`
    & .selectTeacher .rbt-input-hint {
        background: white url(${DownIcon}) right/0.6em auto no-repeat;
        width: 98% !important;
        height: 48px;
    }
`;

const StyledCard = styled(Card)`
    border: 1px solid #e4e4e4;
    border-radius: 8px;
    background: #ffffff;
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.12);
    padding: 0.6em;
    padding-right: 1.2em;
`;

const StyledTopActivityCard = styled.div`
    border-bottom: 1px solid rgb(150, 84, 255);
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const StyledTableActivityThead = styled.thead`
    align-items: center;
    justify-content: center;
    height: 50px;
    display: flex;
`;

const StyledTableActivityDiv = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
`;

const StyledTableActivityTH = styled.th`
    height: 50px;
`;

const StyledTableActivityTd = styled.td`
    border: 0 0 1px 1px solid #e4e4e4;
`;

const StyledTimeDiv = styled.div`
    width: 35%;
    text-align: start;
    border: solid 1px #f0f2f2;
    padding: 12px 8px 0 0;
`;

const StyledPaddingLeft = styled.div`
    padding-left: 24px;
`;

const inputNumberHourStyles = (props: any) => ({
    border: "none",
    borderBottom: "1px solid #787878",
    height: "48px",
    width: props.width || "150px",
    margin: 0,
    borderRadius: 0,
    paddingTop: "1.3rem",
});

const disabledInputTypeHourStyle = {
    backgroundColor: "#F0F2F2",
    border: "1px solid #E4E4E4",
    borderRadius: "4px",
    width: "150px",
    color: "#787878",
    padding: "6px 12px",
    margin: 0,
};

const tableConsultProfileStyles = {
    padding: "24px 25px 32px",
    border: "1px solid #F0F2F2",
    transition: "500ms",
};

const StyledSemesterDiv = styled.div`
    display: flex;
    flex-direction: column;
    width: 286px;
    height: 48px;
    border: 1px solid #e4e4e4;
    background-color: #f0f2f2;
    color: #787878;
    padding: 4px 16px;
    border-radius: 4px;
    margin-bottom: 26px;
`;

const StyledSemesterParagraph = styled.p`
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    margin: 0;
`;

const StyledAlertBox = styled.span`
    color: #1e1e1e;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
    background: #fffdd9;
    padding: 16px;
    border-radius: 16px;
`;

const StyledValidity = styled.p`
    font-size: 15px;
    color: #404040;
    margin: 0;
`;

export {
    StyledCardTitle,
    StyledCardTeacher,
    StyledCardHour,
    StyledCardAvailableHours,
    StyledDefaultButton,
    StyledInformationPlanNotFound,
    StyledTextPlan,
    StyledTitlePlan,
    StyledModalHeader,
    StyledInformationPlan,
    StyledText,
    StyledDefaultButtonLink,
    StyledPrimayButton,
    StyledContainerBody,
    StyledSelectTeacherDiv,
    StyledCard,
    StyledTopActivityCard,
    StyledTableActivityThead,
    StyledTableActivityTH,
    StyledTimeDiv,
    StyledTableActivityDiv,
    StyledTableActivityTd,
    StyledFlexDivSpaceBetween,
    StyledFlexDivAlignCenter,
    StyledFlexDivWithGap,
    StyledSemesterDiv,
    StyledSemesterParagraph,
    inputNumberHourStyles,
    tableConsultProfileStyles,
    disabledInputTypeHourStyle,
    StyledAlertBox,
    StyledValidity,
    StyledTitleHistoric,
    StyledHistoricInfoIcons,
    StyledPaddingLeft,
};
